import React from 'react'
import PublicSiderXS from '../../Layouts/Sider/PublicSiderXS'
import TabletSpecialistForm from './TabletSpecialistForm'

export default function TabletCreateSpecialistAppointmentPage ({ loading, onFinishFailed, sort, minimumAge, onFinish, civilityOptions, initialValues }) {
  return (
    <>
      <PublicSiderXS />
      <TabletSpecialistForm
        loading={loading}
        onFinishFailed={onFinishFailed}
        sort={sort}
        minimumAge={minimumAge}
        onFinish={onFinish}
        civilityOptions={civilityOptions}
        initialValues={initialValues}
      />
    </>
  )
}
